import { faMinus, faPlus } from '@fortawesome/pro-solid-svg-icons';
import { Alert, Card, Empty, InputNumber, Modal, Table } from 'antd';
import Breadcrumb, { Route } from 'antd/lib/breadcrumb/Breadcrumb';
import _ from 'lodash';
import * as React from 'react';
import { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router';
import ListHeader from '../../components/ListHeader';
import { Feature, ProductVersionModel } from '../../models/product-interface';
import { CustomerServiceQueries } from '../../queries/customer-service-queries';
import AddFeaturesModal from '../../components/modals/AddFeatureModal';
import { Link } from 'react-router-dom';
import { ProductQueries } from '../../queries/product-queries';

type Filter = {
  text: string;
  value: number | string;
}

function DemoFeaturesPage() {

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [filteredData, setFilteredData] = useState<Feature[]>(null);
    const [selectedRowKeys, setSelectedRowKeys] = useState<number[]>([]);
    const [filterString, setFilterString] = useState<string | null>(null);
    const [addFeaturesVisible, setAddFeaturesVisible] = useState<boolean>(false);
    const featuresQuery = ProductQueries.useFeaturesList();
    const demoFeatures = CustomerServiceQueries.useDemoFeaturesList()
    const addFeaturesMutator = CustomerServiceQueries.useUpdateDemoFeatures()
    const deleteFeaturesMutator = CustomerServiceQueries.useDeleteDemoFeatures()

    useEffect(() => {
      updateData()
    }, [demoFeatures.data, filterString])

    const updateData = () => {
        let searchedData = demoFeatures.data ?? []
        if(!!filterString) {
            searchedData = searchedData.filter(o => o.name.toLowerCase().includes(filterString.toLowerCase()));
        }

        setFilteredData(searchedData);
    }

    
  const columns: any = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (name: string, record: Feature) => {
        return (name
        )
      },
      sorter: {
        compare: (a: Feature, b: Feature) =>
          a.name.localeCompare(b.name)
      },
    },
    {
      title: 'Record Limit',
      dataIndex: 'recordLimit',
      key: 'recordLimit',
      render: (recordLimit: number, record: Feature) => {
          /*
        if(isDrafting && record.allowLimit) {
          return <InputNumber
            value={record.recordLimit}
            onChange={(val) => {
              var newList = _.cloneDeep(draftFeatureList);
              var feature = newList.find(x => x.id == record.id) as Feature;
              feature.recordLimit = val ?? null;
              setDraftFeatureList(newList);
            }}
            min={0}
          />
        }*/
        
        return recordLimit > 0 ? recordLimit : record.allowLimit ? "Unlimited" : ""
      },
      sorter: {
        compare: (a: Feature, b: Feature) =>
          a.recordLimit == b.recordLimit ? 0 : a.recordLimit > b.recordLimit ? -1 : 1
      },
    },
  ];

    const handleRemoveFeatures = () => {
        Modal.confirm({
            title: `Are you sure you want to remove ${selectedRowKeys.length > 1 ? 'these features' : 'this feature'} from demo companies?`,
            onOk: () => {
              setIsLoading(true)
              var list = _.cloneDeep(demoFeatures.data).filter(x => selectedRowKeys.includes(x.id))
              deleteFeaturesMutator.mutateAsync(list).finally(() => {
                setSelectedRowKeys([])
                setIsLoading(false)
              });
            }
          })
    }
    
    /**
    * On selection changes
    * @param selectedRowKeys
    */
     const onSelectChange = (selectedRowKeys) => {
        setSelectedRowKeys(selectedRowKeys);
        // setValue(value + 1);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange
    };

    /**
     * Unselect all rows
     */
    const handleUnselectAll = () => {
        setSelectedRowKeys([]);
    }

    const handleAddFeaturesToDemoCompanies = (featureList: Feature[]) => {
      setIsLoading(true);
      addFeaturesMutator.mutateAsync(featureList).then(() => {
        setAddFeaturesVisible(false);
      }).finally(() => {
        setIsLoading(false);
      })
    }

    /**
     * Actions for header
     */
     const actions = [
        {
            singleName: "Add Features",
            multiName: "Add Features",
            multiSelect: false,
            alwaysEnabled: selectedRowKeys.length === 0,
            icon: faPlus,
            tag: "AddFeatures",
            forceDisable: selectedRowKeys.length > 0,
            onClick: () => {
                setAddFeaturesVisible(true);
            }
        },{
            singleName: "Remove Feature",
            multiName: "Remove Features",
            multiSelect: true,
            icon: faMinus,
            tag: "RemoveFeatures",
            forceDisable: selectedRowKeys.length === 0,
            onClick: () => {
              handleRemoveFeatures();
            }
        },
    ];

    

  /**
   * Breadcrumb routes
   */
   const routes: Route[] = [
    {
        path: "/admin/search/demo",
        breadcrumbName: 'Demo Companies'
    },
    {
        path: "",
        breadcrumbName: "Features"
    },
  ]

  /**
     * Bread crumb item render
     * @param route 
     * @param _ 
     * @param routes 
     * @returns 
     */
   const itemRender = (route, _, routes) => {
    if (routes.indexOf(route) === routes.length - 1)
        return <Breadcrumb.Item>{route.breadcrumbName}</Breadcrumb.Item>
    return <Link to={route.path}>{route.breadcrumbName}</Link>
}

  return <>
  <Breadcrumb routes={routes} itemRender={itemRender} /><br/>
  <Card title="Demo Features">
    <Alert showIcon message="These features will be added to all companies with the Demo Company flag. Keep in mind demo companies can be of any base product type, so if your adding features that depend on other features, those will also be required her in order to work on lower tiered base product demo companies (ie: Standard)."></Alert><br/>
  <ListHeader 
                    actions={actions}
                    tag="demoFeatures"
                    selectedItems={selectedRowKeys?.length ?? 0}
                    totalItems={demoFeatures.data?.length ?? 0}
                    searchPlaceholder="Search features"
                    unselectAll={handleUnselectAll}
                    onSearch={setFilterString}
                    reset={true}
                />
  <Table
    loading={demoFeatures.isLoading}
    columns={columns}
    rowSelection={rowSelection}
    rowKey={(val) => val.id}
    dataSource={filteredData}
    size="middle"
    locale={{
      emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={`No features set`} />
    }}
    scroll={{ x: 715 }}
    pagination={{defaultPageSize: 50, showTotal: (total,range) => `${range[0]}-${range[1]} of ${total} feature${total !== 1 ? "s" : ""}` }}
  />
    <AddFeaturesModal
      isLoading={isLoading || demoFeatures.isLoading}
      currentFeatures={filteredData}
      allFeatures={featuresQuery.data}
      setIsModalVisible={setAddFeaturesVisible}
      isModalVisible={addFeaturesVisible}
      setIsLoading={setIsLoading}
      handleAddFeatures={handleAddFeaturesToDemoCompanies}
    />
  </Card>
  </>
}


export default DemoFeaturesPage;